import { Box, Typography } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import MuiValidSelect from 'src/components/input/MuiValidSelect';
import BusinessStatusInput from 'src/components/BusinessStatusInput';

const BusinessStatus = () => {
  const { setFieldError, setFieldTouched, setFieldValue, values } = useFormikContext();

  const resetFieldErrors = () => {
    Object.keys(values).forEach((field) => {
      if (field === 'bypassItemization') return;
      if (field === 'paperlessFlag') return;
      setFieldError(field, '');
      setFieldTouched(field, false, false);
    });
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: 'fit-content',
        }}
      >
        <Box>
          <Box sx={{ maxWidth: '8rem' }}>
            <Field
              component={MuiValidSelect}
              itemValues={['active', 'closed', 'bankrupt', 'sold', 'moved']}
              itemLabels={['Open', 'Closed', 'Bankrupt', 'Sold', 'Moved']}
              label="Business Status"
              name="busStatus"
              variant="standard"
              onChange={(e) => {
                setFieldValue('busStatus', e.target.value);
                resetFieldErrors();
              }}
            />
          </Box>
          <Typography mt={2} fontStyle="italic">
            Note: If the business is still in operation you will need to complete the entire Tax
            Statement process. If the business is no longer in operation you may submit the Tax
            Statement after completing this page
          </Typography>
        </Box>

        <Box>{values?.busStatus && BusinessStatusInput[values?.busStatus]}</Box>
      </Box>
    </>
  );
};

export default BusinessStatus;
